module.exports = __webpack_public_path__ + "static/media/createContactNavigation.94a16f42.png";